import Axios, {AxiosResponse} from "axios";
import RootApi from "./root-api";

export default class CountryApi extends RootApi {
    private readonly apiEndpoint: string = `${this.ApiRoot}/countries`;

    public async getCountries(): Promise<AxiosResponse> {
        return await Axios.get(this.apiEndpoint);
    }
}



// WEBPACK FOOTER //
// ./src/api/country-api.ts